import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        operaGroup:[],
        deepsearchToken: null,
        deepsearchTokenExpiry: null
    },
    mutations: {
        setOperaGroup (state,val) {
            state.operaGroup = Object.assign([],val);
        },
        setDeepsearchToken (state, payload) {
            state.deepsearchToken = payload.token;
            state.deepsearchTokenExpiry = payload.expiry;
        },
        clearDeepsearchToken (state) {
            state.deepsearchToken = null;
            state.deepsearchTokenExpiry = null;
        }
    },
    actions: {

    }
});
